import styles from './settings.module.css';
import { FormGroup, Input, Label } from 'reactstrap';
import { useEffect, useRef, useState } from 'react';
import type { CreateImproveAnswerDTO } from '../../service/types';
import {
  useImproveAnswer,
  type ImproveAnswerSettingsType,
} from 'src/components/chat/content/contexts/improveAnswer/context';

interface ModalImproveAnswerSettingsProps {
  isOpen: boolean;
  onClose: () => any;
  onImproveAnswer?: () => any;
  variant?: 'default' | 'fixed';
}

export function ModalImproveAnswerSettings({
  isOpen,
  onClose,
  variant = 'default',
  onImproveAnswer,
  ...props
}: ModalImproveAnswerSettingsProps) {
  const {
    improveAnswerSettings,
    setImproveAnswerSettings,
    handleCreateImprovedAnswer,
  } = useImproveAnswer();

  const [form, setForm] = useState<ImproveAnswerSettingsType>({
    ...improveAnswerSettings,
  });

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!isOpen) {
      setImproveAnswerSettings({
        ...improveAnswerSettings,
        context: [''],
      });
      setForm((prev) => ({
        ...prev,
        context: [''],
      }));
    }
  }, [isOpen]);

  useEffect(() => {
    setImproveAnswerSettings({
      ...improveAnswerSettings,
      tone: form.tone || improveAnswerSettings.tone,
      context: form.context || improveAnswerSettings.context,
    });
  }, [form]);

  useEffect(() => {
    const toneFromLocal = localStorage.getItem(
      'tone'
    ) as CreateImproveAnswerDTO['tone'];

    if (toneFromLocal) {
      setForm((prev) => ({
        ...prev,
        tone: toneFromLocal,
      }));
    }
  }, []);

  if (!isOpen) {
    return <></>;
  }

  return (
    <form
      className={`${styles.modal} ${
        variant === 'fixed' ? styles.modalFixed : ''
      }`}
      {...props}
      onSubmit={() => {
        if (onImproveAnswer) {
          onImproveAnswer();
        } else {
          handleCreateImprovedAnswer();
        }
      }}
    >
      <div className={styles.header}>
        <b>Melhoria de reposta com IA</b>
      </div>

      <div>
        <Input
          type="text"
          id="context"
          placeholder="Digite sua pergunta"
          value={form.context![0]}
          className={styles.inputContext}
          onChange={(event) => {
            setForm((prev) => ({ ...prev, context: [event.target.value] }));
          }}
          innerRef={inputRef}
        />

        <p className={styles.inputContextDescription}>
          A IA irá gerar a resposta focando na sua pergunta específica.
        </p>
      </div>

      <FormGroup style={{ margin: 0 }}>
        <Label htmlFor="tone">Tom de voz</Label>

        <select
          value={form.tone}
          id="tone"
          className="custom-select"
          onChange={(event) => {
            setForm((prev) => ({
              ...prev,
              tone: event.target.value as CreateImproveAnswerDTO['tone'],
            }));
            localStorage.setItem(
              'tone',
              event.target.value as CreateImproveAnswerDTO['tone']
            );
          }}
        >
          <option value="FORMAL">Formal</option>
          <option value="FRIENDLY">Amigável</option>
          <option value="CONVINCING">Convincente</option>
        </select>
      </FormGroup>

      <p className={styles.inputContextDescription}>
        A IA analisará sua conversa para sugerir melhorias no tom e conteúdo
        (usa créditos)
      </p>
    </form>
  );
}
